import browser from '@openclassrooms/utils/browser';
import { scrollToElement } from '@openclassrooms/ui-web/scroll';

import dom from 'lib/dom';
import autoscrollToAnchor from './autoscroll-to-anchor';

export function initSmoothScroll() {
  browser.document.body.addEventListener('click', (event) => {
    const { target } = event;
    const targetElement = target.closest('.js-smoothScroll');

    if (!targetElement) {
      return;
    }

    const match = targetElement.href.match(/#([_a-zA-Z0-9-]+)$/);
    const anchorElementId = match ? match[1] : null;
    const options = dom.getDataFromElement(targetElement, 'scroll');
    const elementToScrollTo = anchorElementId
      ? browser.document.getElementById(anchorElementId)
      : null;

    if (!elementToScrollTo) {
      return;
    }

    event.preventDefault();
    scrollToElement(elementToScrollTo, options);
  });

  autoscrollToAnchor();
}

export default {
  scrollToElement,
  init: initSmoothScroll,
};
